
$(document).ready(function(){
$('.banner-slider-area').owlCarousel({
	     margin:0,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: false,    
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0871/9948/2174/files/right-arrow.png?v=1768815881' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0871/9948/2174/files/left-arrow.png?v=1768815881' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:1
	        },
	        1100:{
	            items:1
	        }
	    }
	}); 
});


// Faq JS Start
  jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
// FAQ JS End


// text-scroll-effect-js-start

document.addEventListener("DOMContentLoaded", function () {
    const spans = document.querySelectorAll(".cubold_scroll_text_section .content h3 span");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                } else {
                    entry.target.classList.remove("active");
                }
            });
        },
        {
            threshold: 1,
        }
    );

    spans.forEach((span) => observer.observe(span));
});

// text-scroll-effect-js-end



$(document).ready(function(){
  $('.merch-carousel').owlCarousel({
    loop: true,
    margin: 30,
    nav: true,
    dots: false,
   navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0871/9948/2174/files/right-arrow.png?v=1768815881' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0871/9948/2174/files/left-arrow.png?v=1768815881' alt='Next'>"
],
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      1024: {
        items: 3
      }
    }
  });
});

